// Slice RTK per i filtri della pagina CDI (`state.cdi_filters`).
//
// Primo slice del progetto: usato come "proof of pattern" per la migrazione
// Fase 6 (Redux switch-style → RTK createSlice). Il root reducer legacy in
// `../reducers/index.js` delega le azioni di `cdi_filters` a questo slice e
// mantiene la legacy state shape (key `cdi_filters` al top level).
//
// Pattern per le slice future:
// 1. Creare il file in `src/store/slices/<nome>Slice.js` con `createSlice`.
// 2. Aggiungere il reducer come delegate nel root (`reducers/index.js`).
// 3. Riesportare il setter dal vecchio `actions/index.js` come back-compat,
//    così i consumer esistenti continuano a funzionare senza modifiche.
// 4. Mantenere il type string dell'action invariato (es. `SET_CDI_FILTERS`)
//    fino a quando tutti i consumer non usano il setter dello slice direttamente.

import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const cdiFiltersSlice = createSlice({
  name: 'cdi_filters',
  initialState,
  reducers: {
    // Sostituisce completamente i filtri (semantica del vecchio
    // `SET_CDI_FILTERS`: il caller fa `{ ...prev, day }` lato componente).
    set: (_state, action) => action.payload ?? {},
    // Update parziale (merge): preferire questo nei consumer nuovi al posto
    // del pattern legacy `setCdiFilters({ ...cdi_filters, day })`.
    update: (state, action) => ({ ...state, ...action.payload }),
    // Reset.
    clear: () => initialState,
  },
});

export const {
  set: setCdiFilters,
  update: updateCdiFilters,
  clear: clearCdiFilters,
} = cdiFiltersSlice.actions;

// Type string esposto per la delega dal root reducer legacy.
export const cdiFiltersActionType = cdiFiltersSlice.actions.set.type;

export default cdiFiltersSlice.reducer;
